import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useMyTrainingHistory } from "../../hooks/useMyTrainingHistory";
import { myTrainingHistoryColumns } from "../MyTrainingHistoryColumns/MyTrainingHistoryColumns";
import { MyTrainingHistoryItem } from "../../api/fetchMyTrainingHistory/types";

const columns = myTrainingHistoryColumns();

const MyTrainingHistoryPage: React.FC = () => {
  const {
    items,
    totalCount,
    loading,
    pagination,
    sorting,
    handlePaginationChange,
    handleSortingChange,
  } = useMyTrainingHistory();

  return (
    <MainPageWrapper
      subtitle="Your event and training records"
      title="My Training History"
    >
      <DataTable<MyTrainingHistoryItem>
        columns={columns}
        data={items}
        loading={loading}
        noDataMessage="No training history found"
        onPageChange={(newPageIndex, newPageSize) =>
          handlePaginationChange({
            pageIndex: newPageIndex,
            pageSize: newPageSize,
          })
        }
        onSortingChange={handleSortingChange}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        rowKeyExtractor={(_row, index) => `${pagination.pageIndex}-${index}`}
        sorting={sorting}
        totalCount={totalCount}
      />
    </MainPageWrapper>
  );
};

export default MyTrainingHistoryPage;
